import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ReplaceUndefinedPipe } from '../../pipes/replaceUndefined.pipe';
import { NgxSpinnerService } from 'ngx-spinner';

export interface IMovimento {
  versione?: number
  id?: number
  idCausale?: number
  causale_Descrizione?: string
  causale_Id_Operazione?: string
  idPosizione?: number;
  
  posizione_Descrizione?: string
  dataRegistrazione?: string
  oraRegistrazione?: string
  numeroFormulario?: string
  dataFormulario?: string
  tipoFormulario?: string
  idDocumentoRifiutiRicopiato?: number
  numDocumentoInterno?: string
  dataDocumentoInterno?: string
  riferimentoDocumento?: string
  scontrino?: string
  idLotto?: number
  idProduttore?: number
  produttore_Descrizione_Soggetto?: string
  produttore_Codice_Fiscale?: string
  produttore_Descrizione_Sede?: string
  produttore_Indirizzo_Sede?: string
  produttore_Civico_Sede?: string
  produttore_Frazione_Sede?: string
  produttore_Comune_Sede?: string
  produttore_CAP_Sede?: string
  produttore_SiglaProvincia_Sede?: string
  produttore_IstatComune_Sede?: string
  idAutorizzazioneProduttore?: number
  autorizzazioneProduttore_Numero?: string
  autorizzazioneProduttore_DataInizio?: string
  autorizzazioneProduttore_DataFine?: string
  idAutorizzazioneProduttoreArea?: number
  idMagazzinoProduttore?: number
  magazzinoProduttore_Descrizione?: string
  idCantiereFuoriUl?: number
  cantiere_Descrizione?: string
  cantiere_Indirizzo?: string
  cantiere_Civico?: string
  cantiere_Frazione?: string
  cantiere_Comune?: string
  cantiere_CAP?: string
  cantiere_SiglaProvincia?: string
  idAttivitaFuoriUl?: string
  attivitaFuoriUl_Descrizione?: string
  idTrasportatore?: number
  trasportatore_Descrizione_Soggetto?: string
  trasportatore_Codice_Fiscale?: string
  trasportatore_Descrizione_Sede?: string
  trasportatore_Indirizzo_Sede?: string
  trasportatore_Civico_Sede?: string
  trasportatore_Frazione_Sede?: string
  trasportatore_Comune_Sede?: string
  trasportatore_CAP_Sede?: string
  trasportatore_SiglaProvincia_Sede?: string
  trasportatore_IstatComune_Sede?: string
  idTrasportatoreAlbo?: number
  idTrasportatoreCategoriaAlbo?: number
  albo_Descrizione?: string
  idAutista?: number
  autista_Cognome?: string
  autista_Nome?: string
  autista_Cognome_Nome?: string
  autista_Matricola?: string
  idAutomezzo?: number
  automezzo_Descrizione?: string
  automezzo_Targa?: string
  automezzo_TipoAutomezzo?: string
  idRimorchio?: number
  rimorchio_Descrizione?: string
  rimorchio_Targa?: string
  rimorchio_TipoAutomezzo?: string
  idDestinatario?: number
  destinatario_Descrizione_Soggetto?: string
  destinatario_Codice_Fiscale?: string
  destinatario_Descrizione_Sede?: string
  destinatario_Indirizzo_Sede?: string
  destinatario_Civico_Sede?: string
  destinatario_Frazione_Sede?: string
  destinatario_Comune_Sede?: string
  destinatario_CAP_Sede?: string
  destinatario_SiglaProvincia_Sede?: string
  destinatario_IstatComune_Sede?: string
  idAutorizzazioneDestinatario?: number
  idAutorizzazioneDestinatarioArea?: number
  autorizzazioneDestinatario_Numero?: string
  autorizzazioneDestinatario_DataInizio?: string
  autorizzazioneDestinatario_DataFine?: string
  idTipoCarico?: string
  idOperazioneRD?: string
  idArea?: number
  idMagazzinoDestinatario?: number
  magazzinoDestinatario_Descrizione?: string
  idIntermediario?: number
  intemediario_Descrizione_Soggetto?: string
  intemediario_Codice_Fiscale?: string
  intemediario_Descrizione_Sede?: string
  intemediario_Indirizzo_Sede?: string
  intemediario_Civico_Sede?: string
  intemediario_Frazione_Sede?: string
  intemediario_Comune_Sede?: string
  intemediario_CAP_Sede?: string
  intemediario_SiglaProvincia_Sede?: string
  intemediario_IstatComune_Sede?: string
  idIntermediarioAlbo?: number
  idIntermediarioCategoriaAlbo?: number
  autorizzazioneItemediarioAlbo_Numero?: string
  autorizzazioneItemediarioAlbo_DataInizio?: string
  autorizzazioneItemediarioAlbo_DataFine?: string
  cer?: string
  ceR_Descrizione?: string
  riferimentoCER?: string
  idStatoFisico?: string
  statoFisico_Descrizione?: string
  isUrbano?: boolean
  quantitaOrigineKg?: number
  unitaMisura?: string
  daVerificareADestino?: boolean
  peso?: number
  volume?: number
  unitaMisuraVolume?: string
  dataAccettazione?: string
  tipoAccettazione?: string
  qtaRespinta?: number
  unitaMisuraQtaRespinta?: string
  idMotivoRespinta?: number
  descrizioneRespinta?: string
  idCategoriaDocumento?: number
  categoriaDocumento_Descrizione?: string
  idTipoDocumento?: number
  tipoDocumento_Descrizione?: string
  idZonaDocumento?: number
  zonaDocumento_Descrizione?: string
  listaHP?: string[]
  caratteristiche_di_pericolo?: string
  caratteristicheChimiche?: string
  descrizioneAssegnata?: string
  idRecup?: string
  idBasilea?: string
  bod?: number
  cod?: number
  analisiNumero?: string
  analisiData?: string
  scadenza?: string
  tipoAnalisi?: string
  annotazioni?: string
  dataInizioTrasporto?: string
  oraInizioTrasporto?: string
  dataFineTrasporto?: string
  oraFineTrasporto?: string
  idClasseAdr?: string
  classeAdr_Descrizione?: string
  idONU?: string
  onU_Descrizione?: string
  numeroColli?: number
  idImballo?: number
  imballo_Descrizione?: string
  percorso?: string
  dataLordoPesa?: string
  oraLordoPesa?: string
  mpLordoPesa?: string
  kgLordoPesa?: number
  dataTaraPesa?: string
  oraTaraPesa?: string
  mpTaraPesa?: string
  kgTaraPesa?: number
  isAvvenutoSmaltimento?: boolean
  tipoRaee?: string
  idCategoriaRaee?: string
  categoriaRaee_Descrizione?: string
  imballaggioRicevuto?: string
  prodottoDaImballaggi?: string
  isAlluminio?: boolean
  idCausaleCobat?: string
  causaleCobat_Descrizione?: string
  idProdottoCobat?: string
  prodottoCobat_Descrizione?: string
  idCausaleConou?: string
  causaleConou_Descrizione?: string
  idProdottoConou?: string
  prodottoConou_Descrizione?: string
  percentualeConou?: number
  operazioneVeicoliFuoriUso?: string
  idSecondoTrasportatore?: number
  secondoTrasportatore_Descrizione?: string
  idAlboSecondoTrasportatore?: number
  alboSecondoTrasportatore_Descrizione?: string
  idTerzoTrasportatore?: number
  terzoTrasportatore_Descrizione?: string
  idAlboTerzoTrasportatore?: number
  alboTerzoTrasportatore_Descrizione?: string
  idQuartoTrasportatore?: number
  quartoTrasportatore_Descrizione?: string
  idAlboQuartoTrasportatore?: number
  alboQuartoTrasportatore_Descrizione?: string
  idSecondoIntermediario?: number
  secondoIntermediario_Descrizione?: string
  idAutorizzSecondoIntermediario?: number
  autorizzSecondoIntermediario_Descrizione?: string
  idTerzoIntermediario?: number
  terzoIntermediario_Descrizione?: string
  idAutorizzTerzoIntermediario?: number
  autorizzTerzoIntermediario_Descrizione?: string
  idQuartoIntermediario?: number
  quartoIntermediario_Descrizione?: string
  idAutorizzQuartoIntermediario?: number
  autorizzQuartoIntermediario_Descrizione?: string
  idRegistroCarico?: number
  idRegistroScarico?: number
  idRegistroTrasporto?: number
  idRegistroIntermediario?: number
  idRegistroRentriCarico?: string
  idRegistroRentriScarico?: string
  idRegistroRentriTrasporto?: string
  idRegistroRentriIntermediario?: string
  registro_Descrizione_Carico?: string
  registro_Descrizione_Scarico?: string
  registro_Descrizione_Trasporto?: string
  registro_Descrizione_Intermediario?: string
  registro_Descrizione_Rentri_Carico?: string
  registro_Descrizione_Rentri_Scarico?: string
  registro_Descrizione_Rentri_Trasporto?: string
  registro_Descrizione_Rentri_Intermediario?: string
  listaCarichiDaAbbinare?: IListaCarichiDaAbbinare[]
  elencoProtocolliCarichiAbbinati?: string
  xSeRecupero?: string
  xSeSmaltimento?: string
  xSeCarico?: string
  xSeScarico?: string
}

export interface IListaCarichiDaAbbinare {
  contatore?: number
  idCarico?: number
  idScarico?: number
  idMovimento?: number
  dataRegistrazione?: string
  oraRegistrazione?: string
  causale?: string
  cer?: string
  idStatoFisico?: string
  riferimento?: string
  elencoHP?: string
  idMagazzino?: number
  descrMagazzino?: string
  idOperazioneRD?: string
  pesoCaricato?: number
  totaleScaricato?: number
  residuo?: number
  pesoScaricato?: number
  idTipoCarico?: string
  
}


@Component({
  selector: 'app-dettagli-movimenti-carico-scarico',
  templateUrl: './dettagli-movimenti-carico-scarico.component.html',
  styleUrls: ['./dettagli-movimenti-carico-scarico.component.css'],
  providers:[ReplaceUndefinedPipe]
})
export class DettagliMovimentiCaricoScaricoComponent implements OnInit {

  @Input() idMovimento? : number=0;
  @Input() api?:string;
  loadingVisible:boolean=false;
  movimentoSelected? : IMovimento;

  constructor(private spinner: NgxSpinnerService,private httpClient : HttpClient) { }

  async ngOnInit() {
    //alert(this.api)
    if(this.idMovimento<0)
      return;
    this.changeMovimento(this.idMovimento);
  }
  async changeMovimento(idMovimento?:number){
    if(idMovimento<1){
      this.idMovimento=0;
      this.movimentoSelected=undefined;
      return;
    }
    else{
      this.idMovimento=idMovimento;
      this.loadingVisible=true;    

      let ciccio=this.httpClient.get<IMovimento>(environment.BASE_API_URL.concat(this.api+`/${idMovimento ? idMovimento : this.idMovimento}`)).toPromise();
      ciccio.then(result=>{
        this.movimentoSelected=result;
        this.loadingVisible=false;     
      }).catch(erro=>{
        this.movimentoSelected=undefined;
        this.loadingVisible=false;   
      })

    /* this.httpClient.get<IMovimento>(environment.BASE_API_URL.concat(`MovimentoRifiuti/${idMovimento ? idMovimento : this.idMovimento}`)).subscribe(result=>{
        this.movimentoSelected=result;
        this.loadingVisible=false;     
      })*/
    

    }

    //this.movimentoSelected = await this.httpClient.get<IMovimento>(environment.BASE_API_URL.concat(`MovimentoRifiuti/${idMovimento ? idMovimento : this.idMovimento}`)).toPromise();



  }




}
